export const PRIMARYCOLOR = '#ADCF41';
export const SECONDARYCOLOR = '#252525';
export const BACKGROUNDCOLOR = '#F6F6F6';
